import * as React from 'react';
import { Animated, Easing, StyleSheet, View, Text } from 'react-native';

import styles from './style';
const loadingImg =
    'https://s.qunarzz.com/q_design_font/images/circleLoading.png';


export default class circle extends React.PureComponent{

    constructor(props) {
        super(props);

        this.state = {
            loadingAngle: new Animated.Value(0)
        };

        this.isAnimating = false;
        this.animateEvent = null;
    }

    animateStart() {
        if (!this.isAnimating) {
            return;
        }

        this.state.loadingAngle.setValue(0);
        this.animateEvent = Animated.timing(this.state.loadingAngle, {
            toValue: 1,
            duration: 1000,
            easing: Easing.linear,
            useNativeDriver: true
        }).start(() => this.animateStart());
    }

    componentDidMount() {
        this.isAnimating = true;
        this.animateStart();
    }

    componentWillUnmount() {
        this.isAnimating = false;

        if (this.animateEvent) {
            this.animateEvent.stop();
            this.animateEvent = null;
        }
    }

    render() {
        const rotate = this.state.loadingAngle.interpolate({
            inputRange: [0, 1],
            outputRange: ['0deg', '360deg']
        });

        return (
            <View style={styles.loadingWrapper}>
                <Animated.Image
                    style={[
                        styles.loaingImg,
                        {
                            transform: [{ rotate }]
                        }
                    ]}
                    resizeMode="contain"
                    source={{ uri: loadingImg }}
                />
                <Text style={styles.loadingText}>
                    加载中
                </Text>
            </View>
        );
    }
}

